// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --appBlack: #000000;
  --inactiveIcon: #8a8c91;
  --activeIcon: white;
  --activeIconRed: red;
  --popupBackground: #2d2f39;
  --legendRed: #e72416;
  --legendYellow: #ffe08f;
  --frontBlue: #0178ae;
  --legendGreen: #83b643;
  --lighterGreen: #8cff0053;
  --textDetails: #ec6728;
  --inputError: #d60d25;
  --inputSuccess: #12b76a;
  --statusBlue: #3f7bf3;
  --sectionHeadlineText: #54778e;
  --sfOrangeLight: #ff8e58;
  --badgeBg: #f7ddd0;
}

.NavMenu-module_trigger___sNSlI {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.8rem 1rem;
  border: none;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  font-size: 1.3rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
  transition: color 120ms ease;
}
.theme--light .NavMenu-module_trigger___sNSlI {
  color: #888888;
}
.theme--light .NavMenu-module_trigger___sNSlI:hover {
  color: #212121;
}
.theme--dark .NavMenu-module_trigger___sNSlI {
  color: #a3a3a3;
}
.theme--dark .NavMenu-module_trigger___sNSlI:hover {
  color: #f0f0f0;
}
.theme--light .NavMenu-module_trigger___sNSlI[data-is-open=true] {
  color: #212121;
}
.theme--dark .NavMenu-module_trigger___sNSlI[data-is-open=true] {
  color: #f0f0f0;
}
.NavMenu-module_trigger___sNSlI[data-is-open=true] .NavMenu-module_triggerChevron___Bq3oJ {
  transform: rotate(180deg);
}

.NavMenu-module_customTrigger___jbgSB {
  padding: 0;
  text-transform: none;
  letter-spacing: normal;
}

.NavMenu-module_triggerLabel___go2hs {
  line-height: 1;
}

.NavMenu-module_triggerChevron___Bq3oJ {
  transition: transform 150ms ease;
}

.NavMenu-module_panel___roCjp {
  position: fixed;
  z-index: 101;
  min-width: 21rem;
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0.6rem;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  animation: NavMenu-module_navMenuIn___aURTu 120ms ease-out;
}
.theme--light .NavMenu-module_panel___roCjp {
  background-color: #ffffff;
  border: 1px solid #dddddd;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
.theme--dark .NavMenu-module_panel___roCjp {
  background-color: #1c1c1c;
  border: 1px solid #2f2f2f;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.NavMenu-module_item___uxtJS {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  padding: 0.9rem 1.2rem;
  border: none;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  font-size: 1.4rem;
  text-align: left;
  white-space: nowrap;
}
.theme--light .NavMenu-module_item___uxtJS {
  color: #212121;
}
.theme--light .NavMenu-module_item___uxtJS:hover {
  background-color: #dddddd;
}
.theme--dark .NavMenu-module_item___uxtJS {
  color: #f0f0f0;
}
.theme--dark .NavMenu-module_item___uxtJS:hover {
  background-color: #2f2f2f;
}
.NavMenu-module_item___uxtJS:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.NavMenu-module_submenuItem___YIMhH {
  font-size: 1.35rem;
}

.NavMenu-module_itemLabel___t0aIx {
  overflow: hidden;
  text-overflow: ellipsis;
}

.NavMenu-module_itemChevron___oJpFU {
  flex-shrink: 0;
}
.theme--light .NavMenu-module_itemChevron___oJpFU {
  color: #888888;
}
.theme--dark .NavMenu-module_itemChevron___oJpFU {
  color: #a3a3a3;
}

.theme--light .NavMenu-module_submenuTrigger___KI_qZ[data-is-open=true] {
  background-color: #dddddd;
}
.theme--dark .NavMenu-module_submenuTrigger___KI_qZ[data-is-open=true] {
  background-color: #2f2f2f;
}

.NavMenu-module_submenuPanel___DuE5R {
  position: fixed;
  z-index: 102;
  min-width: 22rem;
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0.6rem;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}
.theme--light .NavMenu-module_submenuPanel___DuE5R {
  background-color: #ffffff;
  border: 1px solid #dddddd;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
.theme--dark .NavMenu-module_submenuPanel___DuE5R {
  background-color: #1c1c1c;
  border: 1px solid #2f2f2f;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.NavMenu-module_newBadge___iVXQe {
  flex-shrink: 0;
  padding: 0.2rem 0.8rem;
  border-radius: 999px;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--textDetails);
  background-color: var(--badgeBg);
}

.NavMenu-module_countBadge___fScxE {
  flex-shrink: 0;
  min-width: 2rem;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  text-align: center;
  font-size: 1.1rem;
  font-weight: 600;
  color: #ffffff;
  background-color: var(--textDetails);
}

@keyframes NavMenu-module_navMenuIn___aURTu {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/_index.scss","webpack://./src/components/topNav/NavMenu.module.scss"],"names":[],"mappings":"AAOA;EACC,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,8BAAA;EACA,wBAAA;EACA,kBAAA;ACND;;AAhBA;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,4BAAA;AAmBD;ADqEE;ECrFA,cAAA;AAmBF;AAjBE;EACC,cAAA;AAmBH;AD+DE;ECrFA,cAAA;AAyBF;AAvBE;EACC,cAAA;AAyBH;ADyDE;EC5EC,cAAA;AAsBH;ADsDE;EC5EC,cAAA;AAyBH;AArBC;EACC,yBAAA;AAuBF;;AAnBA;EACC,UAAA;EACA,oBAAA;EACA,sBAAA;AAsBD;;AAnBA;EACC,cAAA;AAsBD;;AAnBA;EACC,gCAAA;AAsBD;;AAnBA;EACC,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,0DAAA;AAsBD;ADmBE;ECtCA,yBAAA;EACA,yBAAA;EACA,0CAAA;AAsBF;ADcE;ECtCA,yBAAA;EACA,yBAAA;EACA,0CAAA;AA2BF;;AAvBA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AA0BD;ADPE;EChBA,cAAA;AA0BF;AAxBE;EACC,yBAAA;AA0BH;ADbE;EChBA,cAAA;AAgCF;AA9BE;EACC,yBAAA;AAgCH;AA5BC;EACC,YAAA;EACA,mBAAA;AA8BF;;AA1BA;EACC,kBAAA;AA6BD;;AA1BA;EACC,gBAAA;EACA,uBAAA;AA6BD;;AA1BA;EACC,cAAA;AA6BD;ADpCE;ECUA,cAAA;AA6BF;ADvCE;ECUA,cAAA;AAgCF;;AD1CE;ECgBA,yBAAA;AA8BF;AD9CE;ECgBA,yBAAA;AAiCF;;AA7BA;EACC,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAgCD;AD/DE;ECkCA,yBAAA;EACA,yBAAA;EACA,0CAAA;AAgCF;ADpEE;ECkCA,yBAAA;EACA,yBAAA;EACA,0CAAA;AAqCF;;AAjCA;EACC,cAAA;EACA,sBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gCAAA;AAoCD;;AAjCA;EACC,cAAA;EACA,eAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,oCAAA;AAoCD;;AAjCA;EACC;IACC,UAAA;IACA,2BAAA;EAoCA;EAjCD;IACC,UAAA;IACA,wBAAA;EAmCA;AACF","sourcesContent":["@use \"sass:map\";\r\n\r\n$breakPointM: 1024px;\r\n$breakPointS: 768px;\r\n$breakPointHeightL: 900px;\r\n$breakPointHeightXL: 2200px;\r\n\r\n:root {\r\n\t--appBlack: #000000;\r\n\t--inactiveIcon: #8a8c91;\r\n\t--activeIcon: white;\r\n\t--activeIconRed: red;\r\n\t--popupBackground: #2d2f39;\r\n\t--legendRed: #e72416;\r\n\t--legendYellow: #ffe08f;\r\n\t--frontBlue: #0178ae;\r\n\t--legendGreen: #83b643;\r\n\t--lighterGreen: #8cff0053;\r\n\t--textDetails: #ec6728;\r\n\t--inputError: #d60d25;\r\n\t--inputSuccess: #12b76a;\r\n\t--statusBlue: #3f7bf3;\r\n\t--sectionHeadlineText: #54778e;\r\n\t--sfOrangeLight: #ff8e58;\r\n\t--badgeBg: #f7ddd0;\r\n}\r\n\r\n$themes: (\r\n\tlight: (\r\n\t\tbackgroundPrimary: #f5f6f8,\r\n\t\tsidebarBorder: #dddddd,\r\n\t\ttextPrimary: #212121,\r\n\t\trowWithSoldColor: #212121,\r\n\t\ttextSecondary: #888888,\r\n\t\tborderColor: #dddddd,\r\n\t\tbuttonTertiaryBackground: #ffffff,\r\n\t\tbuttonTertiaryColor: #1f1f1f,\r\n\t\tbuttonTertiaryBorderColor: #e8e8e8,\r\n\t\tinputBackground: #fafafa,\r\n\t\tinputBorderColor: #ddddda,\r\n\t\tsectionBackground: #ffffff,\r\n\t\ttableCellBackground: #ffffff,\r\n\t\ttableHeaderBackground: #f5f6f8,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #cfe1cb,\r\n\t\tholdHighlightedItem: #fff3c4,\r\n\t\trowWithHoldColor: #212121,\r\n\r\n\t\tbuttonPrimaryBackground: #000000,\r\n\t\tbuttonPrimaryBorderColor: #555555,\r\n\t\tbuttonPrimaryTextColor: #ffffff,\r\n\r\n\t\tbuttonSecondaryBackground: #ffffff,\r\n\t\tbuttonSecondaryBorderColor: #dddddd,\r\n\t\tbuttonSecondaryTextColor: #000000,\r\n\r\n\t\tsidebarBackground: #ffffff,\r\n\t\tbuttonOutlineBorder: #8b8b8b,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n\tdark: (\r\n\t\tbackgroundPrimary: #0d0d0d,\r\n\t\tsidebarBorder: #000000,\r\n\t\ttextPrimary: #f0f0f0,\r\n\t\trowWithSoldColor: #f0f0f0,\r\n\t\ttextSecondary: #a3a3a3,\r\n\t\tborderColor: #2f2f2f,\r\n\t\tbuttonTertiaryBackground: #0d0d0d,\r\n\t\tbuttonTertiaryColor: #fafafa,\r\n\t\tbuttonTertiaryBorderColor: #2f2f2f,\r\n\t\tinputBackground: #0d0d0d,\r\n\t\tinputBorderColor: #2f2f2f,\r\n\t\tsectionBackground: #1c1c1c,\r\n\t\ttableCellBackground: #1c1c1c,\r\n\t\ttableHeaderBackground: #1c1c1c,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #4a5c46,\r\n\t\tholdHighlightedItem: #5c5630,\r\n\t\trowWithHoldColor: #f0f0f0,\r\n\r\n\t\tbuttonPrimaryBackground: #ffffff,\r\n\t\tbuttonPrimaryBorderColor: #dddddd,\r\n\t\tbuttonPrimaryTextColor: #000000,\r\n\r\n\t\tbuttonSecondaryBackground: #000000,\r\n\t\tbuttonSecondaryBorderColor: #555555,\r\n\t\tbuttonSecondaryTextColor: #ffffff,\r\n\r\n\t\tsidebarBackground: #000000,\r\n\t\tbuttonOutlineBorder: #dddddd,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n);\r\n\r\n@mixin themed {\r\n\t@each $theme, $map in $themes {\r\n\t\t:global(.theme--#{$theme}) & {\r\n\t\t\t$theme-map: () !global;\r\n\t\t\t@each $key, $submap in $map {\r\n\t\t\t\t$value: map.get($map, $key);\r\n\t\t\t\t$theme-map: map.merge(\r\n\t\t\t\t\t$theme-map,\r\n\t\t\t\t\t(\r\n\t\t\t\t\t\t$key: $value,\r\n\t\t\t\t\t)\r\n\t\t\t\t) !global;\r\n\t\t\t}\r\n\t\t\t@content;\r\n\t\t\t$theme-map: null !global;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@function get($key) {\r\n\t@return map-get($theme-map, $key);\r\n}\r\n\r\n@mixin button-primary {\r\n\tbackground: linear-gradient(135deg, var(--textDetails), #e45210);\r\n\tcolor: white;\r\n\tborder: none;\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: linear-gradient(135deg, #e45210, #d3470e);\r\n\t\ttransform: translateY(-2px);\r\n\t}\r\n}\r\n\r\n@mixin button-secondary {\r\n\t@include themed {\r\n\t\tbackground: get(\"buttonTertiaryBackground\");\r\n\t\tcolor: get(\"buttonTertiaryColor\");\r\n\t\tborder: 1px solid get(\"buttonTertiaryBorderColor\");\r\n\t}\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: var(--textDetails);\r\n\t\tcolor: white;\r\n\t\tborder-color: var(--textDetails);\r\n\t}\r\n}\r\n\r\n@mixin card {\r\n\t@include themed {\r\n\t\tbackground: get(\"sectionBackground\");\r\n\t\tborder: 1px solid get(\"borderColor\");\r\n\t}\r\n\tborder-radius: 12px;\r\n\tpadding: 24px;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\ttransform: translateY(-4px);\r\n\t\tbox-shadow: 0 8px 32px rgba(245, 99, 28, 0.1);\r\n\t}\r\n}\r\n\r\n@mixin section-padding {\r\n\tpadding: 50px 0;\r\n\tborder-radius: 12px;\r\n}\r\n\r\n@mixin container {\r\n\tmax-width: 1200px;\r\n\tpadding: 0 24px;\r\n}\r\n",":root {\n  --appBlack: #000000;\n  --inactiveIcon: #8a8c91;\n  --activeIcon: white;\n  --activeIconRed: red;\n  --popupBackground: #2d2f39;\n  --legendRed: #e72416;\n  --legendYellow: #ffe08f;\n  --frontBlue: #0178ae;\n  --legendGreen: #83b643;\n  --lighterGreen: #8cff0053;\n  --textDetails: #ec6728;\n  --inputError: #d60d25;\n  --inputSuccess: #12b76a;\n  --statusBlue: #3f7bf3;\n  --sectionHeadlineText: #54778e;\n  --sfOrangeLight: #ff8e58;\n  --badgeBg: #f7ddd0;\n}\n\n.trigger {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.8rem 1rem;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  cursor: pointer;\n  font-size: 1.3rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  transition: color 120ms ease;\n}\n:global(.theme--light) .trigger {\n  color: #888888;\n}\n:global(.theme--light) .trigger:hover {\n  color: #212121;\n}\n:global(.theme--dark) .trigger {\n  color: #a3a3a3;\n}\n:global(.theme--dark) .trigger:hover {\n  color: #f0f0f0;\n}\n:global(.theme--light) .trigger[data-is-open=true] {\n  color: #212121;\n}\n:global(.theme--dark) .trigger[data-is-open=true] {\n  color: #f0f0f0;\n}\n.trigger[data-is-open=true] .triggerChevron {\n  transform: rotate(180deg);\n}\n\n.customTrigger {\n  padding: 0;\n  text-transform: none;\n  letter-spacing: normal;\n}\n\n.triggerLabel {\n  line-height: 1;\n}\n\n.triggerChevron {\n  transition: transform 150ms ease;\n}\n\n.panel {\n  position: fixed;\n  z-index: 101;\n  min-width: 21rem;\n  max-height: 70vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0.6rem;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  animation: navMenuIn 120ms ease-out;\n}\n:global(.theme--light) .panel {\n  background-color: #ffffff;\n  border: 1px solid #dddddd;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n}\n:global(.theme--dark) .panel {\n  background-color: #1c1c1c;\n  border: 1px solid #2f2f2f;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n}\n\n.item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  width: 100%;\n  padding: 0.9rem 1.2rem;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  cursor: pointer;\n  font-size: 1.4rem;\n  text-align: left;\n  white-space: nowrap;\n}\n:global(.theme--light) .item {\n  color: #212121;\n}\n:global(.theme--light) .item:hover {\n  background-color: #dddddd;\n}\n:global(.theme--dark) .item {\n  color: #f0f0f0;\n}\n:global(.theme--dark) .item:hover {\n  background-color: #2f2f2f;\n}\n.item:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.submenuItem {\n  font-size: 1.35rem;\n}\n\n.itemLabel {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.itemChevron {\n  flex-shrink: 0;\n}\n:global(.theme--light) .itemChevron {\n  color: #888888;\n}\n:global(.theme--dark) .itemChevron {\n  color: #a3a3a3;\n}\n\n:global(.theme--light) .submenuTrigger[data-is-open=true] {\n  background-color: #dddddd;\n}\n:global(.theme--dark) .submenuTrigger[data-is-open=true] {\n  background-color: #2f2f2f;\n}\n\n.submenuPanel {\n  position: fixed;\n  z-index: 102;\n  min-width: 22rem;\n  max-height: 70vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0.6rem;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n:global(.theme--light) .submenuPanel {\n  background-color: #ffffff;\n  border: 1px solid #dddddd;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n}\n:global(.theme--dark) .submenuPanel {\n  background-color: #1c1c1c;\n  border: 1px solid #2f2f2f;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n}\n\n.newBadge {\n  flex-shrink: 0;\n  padding: 0.2rem 0.8rem;\n  border-radius: 999px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--textDetails);\n  background-color: var(--badgeBg);\n}\n\n.countBadge {\n  flex-shrink: 0;\n  min-width: 2rem;\n  padding: 0.2rem 0.6rem;\n  border-radius: 999px;\n  text-align: center;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #ffffff;\n  background-color: var(--textDetails);\n}\n\n@keyframes navMenuIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trigger": `NavMenu-module_trigger___sNSlI`,
	"triggerChevron": `NavMenu-module_triggerChevron___Bq3oJ`,
	"customTrigger": `NavMenu-module_customTrigger___jbgSB`,
	"triggerLabel": `NavMenu-module_triggerLabel___go2hs`,
	"panel": `NavMenu-module_panel___roCjp`,
	"navMenuIn": `NavMenu-module_navMenuIn___aURTu`,
	"item": `NavMenu-module_item___uxtJS`,
	"submenuItem": `NavMenu-module_submenuItem___YIMhH`,
	"itemLabel": `NavMenu-module_itemLabel___t0aIx`,
	"itemChevron": `NavMenu-module_itemChevron___oJpFU`,
	"submenuTrigger": `NavMenu-module_submenuTrigger___KI_qZ`,
	"submenuPanel": `NavMenu-module_submenuPanel___DuE5R`,
	"newBadge": `NavMenu-module_newBadge___iVXQe`,
	"countBadge": `NavMenu-module_countBadge___fScxE`
};
export default ___CSS_LOADER_EXPORT___;
